// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

import { useEffect, useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import logoImage from "assets/images/Alysio-logo-white.svg";
import { getAPICall } from "lib/callApi";
import { FETCH_SUBSCRIPTION_PLANS, FETCH_INDUSTRIES_LIST, USER_ROLES } from "lib/constants";
import CreateNewCompanyForm from "./CreateNewCompanyForm";

function CreateNewCompany() {
  const [isLoading, setIsLoading] = useState(false);
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [industriesList, setIndustriesList] = useState([]);
  const [companyRolesList, setCompanyRolesList] = useState([]);

  useEffect(() => {
    const fetchPlans = async () => {
      const result = await getAPICall(FETCH_SUBSCRIPTION_PLANS, true);
      if (result?.data?.success) {
        setPlanTypeOptions((result.data.data || []).filter((data) => data?.id));
      }
    };

    const fetchIndustries = async () => {
      const result = await getAPICall(FETCH_INDUSTRIES_LIST, true);
      if (result?.data?.success) {
        setIndustriesList(result.data?.data?.industries || []);
      }
    };

    const fetchCompanyRoles = async () => {
      const result = await getAPICall(USER_ROLES, true);
      if (result?.data?.success) {
        setCompanyRolesList(result?.data?.data || []);
      }
    };
    fetchPlans();
    fetchIndustries();
    fetchCompanyRoles();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} mt={5}>
        {isLoading ? (
          <Stack
            sx={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9,
            }}
          >
            <CircularProgress color="info" size="10vh" />
          </Stack>
        ) : (
          ""
        )}
        <Card sx={{ maxWidth: "500px" }}>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="secondary"
            mx={2}
            mt={-3}
            py={2}
            mb={1}
            textAlign="center"
          >
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "1rem",
                margin: "0 5rem",
              }}
            >
              <MDBox component="img" src={logoImage} alt="Brand" width="100%" />
            </MDBox>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <CreateNewCompanyForm
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              planTypeOptions={planTypeOptions}
              industriesList={industriesList}
              companyRolesList={companyRolesList}
            />
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default CreateNewCompany;
